module.exports = __webpack_public_path__ + "img/home_tablet.8fcc1af1.jpg";